import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { SectionHeading } from "@/components/Bits";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Contact() {
  const [f, setF] = useState({ name: "", email: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);
  const on = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault(); setSending(true);
    try { await api.post("/contact", f); toast.success("Message sent. We'll be in touch."); setF({ name: "", email: "", subject: "", message: "" }); }
    catch { toast.error("Could not send. Please try again."); } finally { setSending(false); }
  };
  return (
    <div className="max-w-6xl mx-auto px-5 md:px-8 pt-14 pb-24 grid lg:grid-cols-2 gap-14">
      <div>
        <SectionHeading eyebrow="Get in touch" title="We'd love to hear from you." />
        <div className="mt-10 space-y-5 text-asure-text2">
          <div className="flex items-start gap-3"><MapPin className="text-asure-forest mt-1" size={18} /><div><div className="font-semibold text-asure-text">ASURE OPC PRIVATE LIMITED</div>Asure Building, Sewai, Nahar Road<br/>Sushant Golf City, Lucknow, UP, India</div></div>
          <div className="flex items-center gap-3"><Mail className="text-asure-forest" size={18} /><a href="mailto:info@asurelife.com" className="hover:text-asure-forest">info@asurelife.com</a></div>
          <div className="flex items-center gap-3"><Phone className="text-asure-forest" size={18} /><a href="tel:+918269784515" className="hover:text-asure-forest">+91 82697 84515</a></div>
        </div>
      </div>
      <form onSubmit={submit} className="card-surface p-8 space-y-4" data-testid="contact-form">
        <Field label="Full Name" v={f.name} on={on("name")} testid="contact-name" />
        <Field label="Email" type="email" v={f.email} on={on("email")} testid="contact-email" />
        <Field label="Subject" v={f.subject} on={on("subject")} testid="contact-subject" />
        <div>
          <label className="eyebrow block mb-2">Message</label>
          <textarea required rows={5} value={f.message} onChange={on("message")} data-testid="contact-message"
            className="w-full border border-[color:var(--asure-border)] rounded-lg px-4 py-3 focus:border-asure-forest outline-none" />
        </div>
        <button className="btn-primary w-full" disabled={sending} data-testid="contact-submit">{sending ? "Sending…" : "Send message"}</button>
      </form>
    </div>
  );
}
function Field({ label, v, on, type = "text", testid }) {
  return (
    <div>
      <label className="eyebrow block mb-2">{label}</label>
      <input required type={type} value={v} onChange={on} data-testid={testid}
        className="w-full border border-[color:var(--asure-border)] rounded-lg px-4 py-3 focus:border-asure-forest outline-none" />
    </div>
  );
}
